export enum EventTypes {
    CheckedIn = "Checked In",
    SMSConfirmationSent = "SMS Confirmation Sent",
    ConsultationSMS1Sent = "Consultation SMS 1 Sent",
    ConsultationSMS2Sent = "Consultation SMS 2 Sent",
    VetServicesStarted = "Vet Services Started",
    CheckedOut = "Checked Out",
    Consultation = "Consultation",
    InProgressStarted = "In Progress Started",
    Admitted = "Admitted",
    FinalizeStarted = "Finalize Started",
    PaidStarted = "Paid Started",
    EnteredVisitAdminMode = "Entered Visit Admin Mode",
    ExitedVisitAdminMode = "Exited Visit Admin Mode"
}
